import type { PropsWithChildren } from 'react'
import * as React from 'react'
import styled from 'styled-components'
import clsx from 'clsx'
import _BaseLabel from './_BaseLabel'

const ExclusiveLabelElement = styled(_BaseLabel)`
  background-color: var(--palette-product-exclusive-background);
  border-color: var(--palette-product-exclusive-foreground);
  color: var(--palette-product-exclusive-contrast);
`

interface Props {
  className?: string
  startIcon?: React.ReactNode
  endIcon?: React.ReactNode
  ref?: React.Ref<HTMLSpanElement>
  format?: React.ComponentProps<typeof _BaseLabel>['format']
}

/**
 * Documentation: <https://aussiecommerce.atlassian.net/wiki/spaces/UXUI/pages/4504289338/Label>
 */
function ExclusiveLabel({ className, ...labelProps }: PropsWithChildren<Props>) {
  return <ExclusiveLabelElement
    className={clsx(
      className,
    )}
    {...labelProps}
  />
}

export default ExclusiveLabel
